import type { Permission } from '../types'

/** Domena PERM = prefiks przed pierwszą kropką (np. `contracts` z `contracts.annex.write`). */
export function domainOf(code: string): string {
  const i = code.indexOf('.')
  return i === -1 ? code : code.slice(0, i)
}

/**
 * Grupuje uprawnienia po domenie. Zwraca pary [domena, perms] posortowane po nazwie domeny,
 * a wewnątrz grupy uprawnienia posortowane po kodzie.
 */
export function groupPermissionsByDomain(permissions: Permission[]): [string, Permission[]][] {
  const map = new Map<string, Permission[]>()
  for (const p of permissions) {
    const domain = domainOf(p.code)
    const arr = map.get(domain) ?? []
    arr.push(p)
    map.set(domain, arr)
  }
  for (const arr of map.values()) {
    arr.sort((a, b) => a.code.localeCompare(b.code))
  }
  return [...map.entries()].sort((a, b) => a[0].localeCompare(b[0]))
}
